import { DatePipe } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  Combo2Service,
  ComboService,
  DesignphotoService,
  SalesOrderService,
} from "../../../services/index";

@Component({
  selector: "addEditPurchaseOrder",
  templateUrl: "./addEditBrandStock.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class addEditBrandStock implements OnInit {
  row: any;
  data: any;
  styleList1: any;
  designdata: any = {};
  varietyList = [];
  varietyList1 = [];
  wodata: any = {
    shirtdno: "",
    party_code: "UNIT 1",
    party_name: "SKT CLOTHING CO",
    halfrate: 0,
    fullrate: 0,
    totalrate: 0,
  };
  designExists: string = "";
  runningDesigns: number = 0;
  runningDesignsTemp: number = 0;
  colorList: any;
  designnoList = [];
  tempDesignnoList = [];
  codeList: any;
  brandList = ["OLIVE", "JOB", "EXPOSE", "OTHER BRANDS"];
  qualityList = ["PC", "COTTON", "LINEN", "JUST LINEN", "SATIN", "SILK"];
  Delivery: boolean = false;
  brand_check: boolean = false;
  job_type_check: boolean = false;
  expose_type_check: boolean = false;
  partyList = [];
  seasonList = [];
  shirttypeList = [];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  salesdata = {
    inward_no: "",
    brand_name: "EXPOSE",
    inward_date: "",
    brand_name_others: "",
    Purchased_By: "",
    purchase_date: "",
    mrp: 0,
    rate: 0,
    remarks: "",
    style: "",
    fit: "",
  };
  widthList = ["36", "44", "58"];
  designList = [
    {
      design_no: "",
      fullQty: 0,
      halfQty: 0,
      color: "",
      mtr: 0,
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      fqty: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      totqty: 0,
      design_id: 0,
      variety_type: "",
      mrp: 0,
      fsrate: 0,
      hsrate: 0,
      width: 0,
      qly: "",
    },
  ];
  mode: string;
  saveEvent: any;
  // brandList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);
    this.salesdata = designdata;
    if (this.mode == "View") {
      this.salesdata.inward_date = this.datePipe.transform(
        this.salesdata.inward_date,
        "yyyy-MM-dd"
      );
      this.loaddesignList(designdata.so_id);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesOrderService,
    private comboservice: ComboService,
    private designservice: DesignphotoService,
    private combo: Combo2Service,
    private change: ChangeDetectorRef
  ) {
    this.row = {
      design_no: "",
      type: "",
      typeid: "",
      rangefrom: "",
      rangeto: "",
      color: "",
      f36: 0,
      f38: 0,
      f40: 0,
      f42: 0,
      f44: 0,
      f46: 0,
      fqty: 0,
      hqty: 0,
      h36: 0,
      h38: 0,
      h40: 0,
      h42: 0,
      h44: 0,
      h46: 0,
      totqty: 0,
      variety_type: "",
      mrp: 0,
      fsrate: 0,
      hsrate: 0,
      width: 0,
      qly: "",
    };
  }
  ngOnInit() {
    this.tableScroll();
    this.getDesignsToDefault();
    this.getVarietyList();
    if (this.mode == "Add") {
      this.salesdata.inward_date = this.datePipe.transform(
        new Date(),
        "yyyy-MM-dd"
      );
      // this.getAuto();
    }
    // this.getTypeList();
    // this.agentCombo();
    // this.getDesignNoList();
  }

  tableScroll() {
    $(".workorderbody").height(window.innerHeight - 400);
    $(".workorderbody").width(window.innerWidth - 30);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#brand_name").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      nextEl = "design_no-0";
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      color = this.designList[ind]["color"],
      f36 = this.designList[ind].f36,
      f38 = this.designList[ind].f38,
      f40 = this.designList[ind].f40,
      f42 = this.designList[ind].f42,
      f44 = this.designList[ind].f44,
      f46 = this.designList[ind].f46,
      h36 = this.designList[ind].h36,
      h38 = this.designList[ind].h38,
      h40 = this.designList[ind].h40,
      h42 = this.designList[ind].h42,
      h44 = this.designList[ind].h44,
      h46 = this.designList[ind].h46,
      totqty = this.designList[ind]["totqty"];

    let nxtRow = $("#row-" + ind).next("tr");
    // let data = this.isRowEmpty(ind);
    if (fld == "design_no" && nxtRow.length == 0) {
      let len = this.designList.length;
      let design_no = this.designList[len - 1].design_no;
      if (design_no != "") {
        for (let i = 0; i < this.designList.length; i++) {
          if (ind + 1 == this.designList.length) {
            this.row.variety_type = this.designList[len - 1].variety_type;
            this.row.mrp = this.designList[len - 1].mrp;
            this.row.fsrate = this.designList[len - 1].fsrate;
            this.row.width = this.designList[len - 1].width;
            this.row.qly = this.designList[len - 1].qly;
            let rowdetail = Object.assign({}, this.row);
            this.designList.push(rowdetail);
            if (this.salesdata.brand_name == "EXPOSE") {
              this.setRunningDesignno();
            }
            nxtInd = this.designList.length - 1;
            $("#" + fld + "-" + nxtInd).focus();
          }
        }
      }
    } else if (
      fld == "f36" ||
      fld == "f38" ||
      fld == "f40" ||
      fld == "f42" ||
      fld == "f44" ||
      fld == "f46"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    } else if (
      fld == "h36" ||
      fld == "h38" ||
      fld == "h40" ||
      fld == "h42" ||
      fld == "h44" ||
      fld == "h46"
    ) {
      $("#" + fld + "-" + nxtInd).select();
    }
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }
  loaddesignList(id) {
    let params = {
      so_id: id,
    };
    this.salesservice.getViewBrandListeDet(params).then((res: any) => {
      this.designList = res.soListRes;

      this.calcRate();
      this.change.detectChanges();
    });
  }
  doSetTimeout(res, i) {
    i = i + 1;
    setTimeout(() => {
      for (var k = 0; k < 10; k++) {
        this.designList.push(res[i + k]);
      }
    }, 500);
  }
  calcTotal($event, ind) {
    let nan = function (no) {
      if (no == "" || no == null || no == undefined) {
        return 0;
      }
      if (isNaN(no)) {
        return 0;
      }
      return parseFloat(no + "");
    };

    let item = this.designList[ind];
    let fqty =
      nan(item.f36) +
      nan(item.f38) +
      nan(item.f40) +
      nan(item.f42) +
      nan(item.f44) +
      nan(item.f46);
    let hqty =
      nan(item.h36) +
      nan(item.h38) +
      nan(item.h40) +
      nan(item.h42) +
      nan(item.h44) +
      nan(item.h46);
    this.designList[ind].fqty = parseFloat("" + fqty);
    this.designList[ind].hqty = parseFloat("" + hqty);
    this.designList[ind].totqty = parseFloat(
      "" +
        (item.f36 +
          item.f38 +
          item.f40 +
          item.f42 +
          item.f44 +
          item.f46 +
          item.h36 +
          item.h38 +
          item.h40 +
          item.h42 +
          item.h44 +
          item.h46)
    );
    this.calcRate();
  }

  calcRate() {
    let item = this.designList;

    let fullrate = 0,
      halfrate = 0,
      totalrate = 0;
    for (let i = 0; i < item.length; i++) {
      fullrate += item[i].fqty;
      halfrate += item[i].hqty;
      if (isNaN(fullrate)) {
        halfrate = 0;
      }
      if (isNaN(halfrate)) {
        halfrate = 0;
      }
      totalrate = fullrate + halfrate;
    }

    this.wodata.fullrate = fullrate;
    this.wodata.halfrate = halfrate;
    this.wodata.totalrate = totalrate;
  }

  isRowEmpty(ind) {
    let data = this.data.designList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  deleteRow(ind) {
    this.designList.splice(ind, 1);
    this.setRunningDesignno();
  }
  setRunningDesignno() {
    let tempDesign = this.runningDesignsTemp;
    this.runningDesigns = tempDesign;
    this.designList.forEach((el, ind) => {
      el.design_no = "FF-" + (Number(this.runningDesigns) + ind);
    });
  }

  onDeleteRow($event, fld, ind) {
    //     onDeleteRow(ind) {
    //  $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.designList.length > 1) {
          that.designList.splice(ind, 1);
          that.calcRate();
          if ($("#" + fld + "-" + (ind - 1)).length > 0) {
            $("#" + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + fld + "-" + (ind + 1)).length > 0) {
            $("#" + fld + "-" + (ind + 1)).focus();
          }
          this.setRunningDesignno();
        }
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAuto() {
    let params = {
      trans_type: "SalesOrder",
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };

    this.salesservice.getAutoNoBrandStock(params).then((res: any) => {
      this.salesdata.inward_no = res;
      this.oncheckemptyrow();
    });
  }

  getDesignsToDefault() {
    let params = {};
    this.salesservice.getDesignsToDefault(params).then((res: any) => {
      if (res.success) {
        this.runningDesigns = res.data.design_no;
        this.runningDesignsTemp = Number(res.data.design_no);
        this.designExists = "FF-" + res.data.design_no;
      } else {
        this.runningDesigns = 100;
        this.runningDesignsTemp = 100;
        this.designExists = "FF-100";
      }
    });
  }

  checkColor(design_id, ind) {
    for (var k = 0; k < this.designList.length; k++) {
      let temp = this.designList[k];
      if (design_id > 0) {
        if (temp.design_id == design_id && ind !== k) {
          swal("DESIGN AND COLOR ALREADY EXIST");
          this.designList[ind].design_no = "";
          this.designList[ind].color = "";
          this.designList[ind].design_id = 0;
        }
      }
    }
  }
  // onSelectdesign(desno, ind) {
  //   if (desno == "") {
  //     this.colorList = [];
  //   } else {
  //     let no = _.filter(this.designnoList, { design_no: desno });
  //     let id = no[0]["des_id"];
  //     let design_no = no[0]["design_no"];
  //     let params = {
  //       des_id: id,
  //       design_no: design_no,
  //     };

  //     this.designservice.getDesignColorList(params).then((res: any) => {
  //       this.colorList = res;
  //       this.change.detectChanges();
  //     });
  //   }
  // }
  // onSelectDesignType(design_type) {

  //   if(design_type == 'NEW'){
  //     design_type = 'DESIGN';
  //   }

  //   this.designnoList = this.tempDesignnoList.filter((el) => el.type == design_type);

  // }
  onSelectbrand(brand) {
    this.job_type_check = false;
    this.brand_check = false;
    this.expose_type_check = false;

    this.salesdata.brand_name = brand;
    this.designList[0].design_no = "";
    if (this.salesdata.brand_name == "OTHER BRANDS") {
      this.brand_check = true;
    } else if (this.salesdata.brand_name == "JOB") {
      this.job_type_check = true;
    } else if (this.salesdata.brand_name == "EXPOSE") {
      this.expose_type_check = true;
      this.designList[0].design_no = this.designExists;
    }
  }

  onSelectStyle(style) {
    if (style == "FORMAL" || style == "STYLISH FORMAL") {
      this.salesdata.fit = "COMFORT FIT";
    } else if (style == "CASUAL") {
      this.salesdata.fit = "RELAX FIT";
    } else if (style == "CLUBWEAR") {
      this.salesdata.fit = "SLIM FIT";
    }
  }
  onSelectType($event, ind) {
    this.designList[ind]["typeid"] = $event.item.id;
  }

  //   getTypeList() {
  //     let params = {};
  //     this.comboservice.gettypeList().then((res: any) => {
  //       this.shirttypeList = res;
  //     });
  //   }
  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
      this.tempDesignnoList = res;
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { genLedid: id });
      return fitem["name"];
    }
    return "";
  }

  onSelectColor(design, color, ind) {
    if (isNaN(color)) {
      color = color.toUpperCase();
    }
    this.colorList.forEach((element) => {
      if (color == element.dispName) {
        //     this.designList[ind]['des_id'] = element.des_id;
        this.designList[ind]["design_id"] = element.design_id;
        this.designList[ind]["shade"] = element.dispName;
      }
    });

    for (var k = 0; k < this.designList.length; k++) {
      let temp = this.designList[k];
      if (temp.design_id == this.designList[ind].design_id && !k == ind) {
        swal("DESIGN AND COLOR ALREADY EXISTS");
      }
    }
  }

  onSelectItem($event, design, ind) {
    let design_no = _.filter(this.data.designList, {
      design_no: design.design_no,
      shade: design.shade,
    });

    if (design_no.length == 1) {
      //   this.onGoToNextFld($event, "quality", ind);
    } else {
      this.toasterService.pop({
        bodyOutputType: 1,
        type: "error",
        title: "ALREADY EXISTS",
        body: "Design with this shade Already Exists",
      });
      design.design_no = "";
      design.shade = "";
    }
  }

  oncheckemptyrow() {
    let design = this.designList;
    let temp = false;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.designList = desList;
    if (this.salesdata.brand_name == "EXPOSE") {
      if (!this.salesdata.style || !this.salesdata.fit) {
        swal("Make sure that all the details are entered!");
        return;
      }

      this.designList.forEach((el) => {
        if (!el.variety_type || !el.width || !el.qly || !el.mrp || !el.fsrate) {
          temp = true;
        }
      });
    }
    if (temp) {
      swal("Make sure that all the details are entered!");
      return;
    } else {
      this.onSaveOrder();
    }
  }

  onSaveOrder(): void {
    if (this.salesdata.brand_name == undefined) {
      swal("Make sure that all the details are entered!");
    } else {
      let params: any = Object.assign({}, this.salesdata);
      params["tabevent"] = undefined;
      params["mode"] = this.mode;
      params["designList"] = JSON.stringify(this.designList);
      params["inward_date"] = this.datePipe.transform(
        params["inward_date"],
        "yyyy-MM-dd"
      );
      params["purchase_date"] = this.datePipe.transform(
        params["purchase_date"],
        "yyyy-MM-dd"
      );

      let that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this brand stock?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.salesservice
          .adduptBrandStockInward(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  getVarietyList() {
    this.combo.varietyStyleCombo().then((res: any) => {
      let list = [...res.data];
      this.varietyList = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.variety === o.variety)) {
          unique.push(o);
        }
        return unique;
      }, []);

      this.varietyList1 = this.varietyList;

      this.styleList1 = list.reduce((unique, o) => {
        if (!unique.some((obj) => obj.style === o.style)) {
          unique.push(o);
        }
        return unique;
      }, []);
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/brandStockInward/addEditBrandStock.ts